import requests from "@/common/fetch";
import { Result, mockResponse } from "../common";
import { toCamelCase, toUnderCase } from "@/common/util/transform";
import * as I from "./interface";
import mockData from "./mock.json";

/**
 * 查询超级账号下，授权的品牌
 * @deprecated check
 */
export const queryAuthBrandInfo = (
  params: I.QueryAuthBrandInfoParams
): Result<I.QueryAuthBrandInfoResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/dmp_common/query/auth/brand",
      toUnderCase(params)
    )
  );
};

/** 查询生意概览数据 */
export const queryBusinessData = (
  params: I.QueryBusinessDataParams
): Result<I.QueryBusinessDataResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/business_gmv/query/list",
      toUnderCase(params)
    )
  );
};

/** 查询生意概览详情数据 */
export const queryBusinessDataDetail = (
  params: I.QueryBusinessDataParams,
  isMock?: boolean
): Result<I.QueryBusinessDataDetailResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/business_gmv/query/detail",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.QueryBusinessDataDetailResult);
};

/** 查询所有授权店铺及品牌的二级品牌类目信息 */
export const queryAuthBrandCate2 = (
  params: I.QueryAuthBrandCate2Params
): Result<I.QueryAuthBrandCate2Result> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/business_gmv/brand_cate2_info",
      toUnderCase(params)
    )
  );
};
